import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RgActivityList } from '../../../shared/interfaces/rg-activity-list.interface';


@Injectable({
  providedIn: 'root'
})
export class ActivitiesTsService {
  private selectedRowsSubject = new BehaviorSubject<Number[]>([]);
  selectedRows$ = this.selectedRowsSubject.asObservable();

  setSelectedRows (rows: Number[]) {
    this.selectedRowsSubject.next(rows);
  }
}
